// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"0ec48876f4f0d42336f7","532":"2e3f981e965120db9d0f","691":"3dc08912b4fc3679c086"}[chunkId] + ".js";
};